import React from 'react'
import { geoPath, geoGraticule10 } from 'd3-geo'
import WorldH from '../../geo/land_high'
import WorldM from '../../geo/land_medium'
import WorldL from '../../geo/land_low'
import BordersGeo from '../../geo/borders'
import styled from 'styled-components'

const Land = styled.g`
  stroke-width: 0;
  stroke: rgb(0, 43, 60);
  fill: #a8d3d6;
  pointer-events: 'none';
`

const Graticule = styled.g`
  fill: none;
  stroke: #444;
  stroke-width: 0.5px;
  stroke-dasharray: 3 5;
  pointer-events: 'none';
`
const Borders = styled.g`
  fill: none;
  stroke-width: 1px;
  stroke: #f8f8f8;
  pointer-events: 'none';
`

const World = ({ p, zoom, move }) => {
  const geo = d => {
    return geoPath().projection(p())(d)
  }

  return (
    <>
      <Graticule>
        <path key={`grat`} d={geo(geoGraticule10())} className="graticule" />
      </Graticule>
      <Land>
        {(move ? WorldL : zoom > 1800 ? WorldH : WorldM).map((d, i) => (
          <path key={`l-${i}`} d={geo(d)} />
        ))}
      </Land>
      <Borders>{!move && BordersGeo.map((d, i) => <path key={`l-${i}`} d={geo(d)} />)}</Borders>
    </>
  )
}

export default World
